import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { OTPublisher } from 'opentok-react';
import i18n from '../../../config/i18n';
// import RadioButtons from './RadioButtons';
// import CheckBox from './CheckBox';

export default class Publisher extends Component {
  static propTypes = {
    actions: PropTypes.shape({
      createDangerAlert: PropTypes.func.isRequired,
    }).isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      error: null,
      audio: true,
      video: true,
      videoSource: 'camera',
    };
  }

  onError = (err) => {
    const { actions: { createDangerAlert } } = this.props;
    if (err.name === 'OT_USER_MEDIA_ACCESS_DENIED') createDangerAlert(i18n.t('mediaErrorMessage'));
    this.setState({ error: `Failed to publish: ${err.message}` });
  }

  setVideoSource = (videoSource) => {
    this.setState({ videoSource });
  }

  setVideo = (video) => {
    this.setState({ video });
  }

  setAudio = (audio) => {
    this.setState({ audio });
  }

  render() {
    const { videoDimensions } = this.props;
    return (
      <div>
        <OTPublisher
          properties={{
            publishAudio: this.state.audio,
            publishVideo: this.state.video,
            videoSource: this.state.videoSource === 'screen' ? 'screen' : undefined,
            ...videoDimensions,
          }}
          onError={this.onError}
        />
        {/* <RadioButtons // may need to add functions later
          buttons={[
            {
              label: 'Camera',
              value: 'camera',
            },
            {
              label: 'Screen',
              value: 'screen',
            },
          ]}
          initialChecked={this.state.videoSource}
          onChange={this.setVideoSource}
        />
        <CheckBox
          label="Publish Audio"
          initialChecked={this.state.audio}
          onChange={this.setAudio}
        />
        <CheckBox
          label="Publish Video"
          initialChecked={this.state.video}
          onChange={this.setVideo}
        /> */}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/messaging/videoChat/Publisher.js